import { TSESTree } from '@typescript-eslint/types';

interface ParserTypescriptModule {
  parsers: {
    typescript: {
      parse: (arg: unknown) => TSESTree.Program;
    };
  };
}

declare const window: {
  require: (paths: string[], cb: (module: ParserTypescriptModule) => void) => void;
};

export function getExpressionAstByModel(model: string): Promise<TSESTree.Program> {
  return new Promise((resolve, reject) => {
    window.require([`/assets/prettier/parser-typescript.js`], ({ parsers }) => {
      try {
        const ast = parsers.typescript.parse(model);
        resolve(ast);
      } catch (e) {
        reject(e);
      }
    });
  });
}
